import React from 'react';

import { LineItemContainer } from '../style';
import { NameValuePair } from '../../models';

type Props = { 
    key: number | string;
    lineItems: NameValuePair[];
};

const renderLineItem = (entries: NameValuePair[]) => {
    const html = [];
    entries.forEach(({name, value}) => {
        html.push(
            <>
                <LineItemContainer>
                    <div><strong>{name}:&nbsp;</strong></div>
                    <div>{value}</div>
                </LineItemContainer>
            </>);
    });
    return html;
};

export default function OrderLineItem({ lineItems }: Props) {
    return (
        <>
            {lineItems?.length && renderLineItem(lineItems)}
        </>
    )
}
